<template>

	<!--PC	-->
	<div style=" line-height: 65px;display: flex;background:transparent;position: fixed;z-index: 999;width: 100%;padding-top: 10px;margin-top: 0"
		 :class="{backgroundChange:backgroundChange}"
	>
		<!--		-webkit-box-shadow: black 0 0 10px ;-->

		<div v-show=" isPC">

			<div class="logo" ><a href="/en/Home" style="display: inline-block"><img src="../assets/logo.png" alt="logo" style="width: 230px;height: 65px;" title="logo"></a></div>


			<div style="right: 0;position: absolute;top:0">

				<el-menu
						:default-active="this.$route.path"
						class="el-menu-demo"
						mode="horizontal"
						:ellipsis='false'

						active-text-color="#000000"
						@select="handleSelect"
						router
						:unique-opened="true"
						:router="true"

						:class="{backgroundChange:backgroundChange}"


				>
					<!--					active-text-color="rgb(255,63,63)"-->
					<el-menu-item class="item" index="/en/Home" >Home</el-menu-item>
					<el-menu-item class="item" index="/About/en" >About us</el-menu-item>



					<el-menu-item class="item" index="/Products/en" >Product</el-menu-item>
					<el-menu-item class="item" index="/Contact/en" >Contact us</el-menu-item>
					<el-menu-item class="item" index="/News/en" >News</el-menu-item>

					<el-sub-menu >


						<template #title ><img src="../assets/icon-en.gif" title="zh" alt="fantizhongwen"> English</template>
						<el-menu-item index="/"><img src="../assets/58ad14ebN0a8d1f14.jpg" title="zh" alt="fantizhongwen">简体中文</el-menu-item>
						<el-menu-item index="/cht"><img src="../assets/icon-hk.gif" title="hk" alt="fantizhongwen">繁体中文</el-menu-item>
						<el-menu-item index="/en"><img src="../assets/icon-en.gif" title="en" alt="fantizhongwen">English</el-menu-item>
						<el-menu-item index="/de"><img src="../assets/icon-de.gif" title="de" alt="fantizhongwen">Deutsch</el-menu-item>

					</el-sub-menu>



				</el-menu>

			</div>
		</div>
		<div v-show="show" style="width: 100%;">
			<ul>
				<li style="float: left">
					<div class="logoModel"><a href="/en/Home" style="display: inline-block"><img src="../assets/logo.png" alt="logo" title="logo" style="width: 230px;height: 65px;"></a></div>
				</li>

				<li style=" float:right;margin-right: 5px">
					<div class="logoModel" >
						<el-button icon="el-icon-menu" circle @click="toggleShopShow"></el-button>
					</div>

				</li>
			</ul>
		</div>
	</div>



	<!--	移动端-->
	<div v-show = "!isPC" style="background:transparent;position: fixed;z-index: 999;width: 100%;box-shadow: 0px 5px 10px #DDDDDD;">
		<!--		<transition name="el-zoom-in-top">-->
		<div style="height: 50px;background: white">
			<el-row>
				<el-col :span="6"><div style="padding-left: 10px" @click="phoneNav = !phoneNav,phoneNav2 = false"><i :class="{'el-icon-menu':!phoneNav,'el-icon-close':phoneNav}" style="color: #409eff;font-size: 2rem;line-height: 50px;"></i></div></el-col>
				<el-col :span="12"><div style="text-align: center"><a href="/en/Home" style="display: inline-block"><img src="../assets/logo.png" alt="logo" title="logo" style="width: 177px;height: 50px;"></a></div></el-col>
				<el-col :span="6">
					<div style="padding-right: 10px;height: 50px; display: flex;align-items: center;justify-content: flex-end" @click="phoneNav = false,phoneNav2 = !phoneNav2">

						<img src="../assets/icon-en.gif" title="zh" alt="fantizhongwen">
					</div>
				</el-col>


			</el-row>
		</div>
		<div style="" class="phoneNav " v-show="phoneNav" >


			<ul>
				<li><h3><a href="/en/Home">Home</a></h3></li>
				<li><h3><a href="/About/en">About us</a></h3></li>
				<li><h3><a href="/Products/en">Product</a></h3></li>
				<li><h3><a href="/Contact/en">Contact us</a></h3></li>
				<li><h3><a href="/News/en">News</a></h3></li>

			</ul>


		</div>
		<div style="" class="phoneNav2" v-show="phoneNav2" >

			<el-row>
				<el-col :span="6"><a href="/"><img src="../assets/58ad14ebN0a8d1f14.jpg" title="zh" alt="fantizhongwen"><p>简体中文</p></a></el-col>
				<el-col :span="6"><a href="/cht"><img src="../assets/icon-hk.gif" title="zh" alt="fantizhongwen"><p>繁体中文</p></a></el-col>
				<el-col :span="6"><a href="/en"><img src="../assets/icon-en.gif" title="zh" alt="fantizhongwen"><p>English</p></a></el-col>
				<el-col :span="6"><a href="/de"><img src="../assets/icon-de.gif" title="zh" alt="fantizhongwen"><p>Deutsch</p></a></el-col>
			</el-row>



		</div>
		<!--		</transition>-->
	</div>
</template>

<script>
	import request from "@/utils/request";

	export default {
		name: "Header",
		data() {
			return {
				activeIndex: '1',
				type:true,
				url:"../assets/logo.png",
				isPC:false,
				show:false,
				list:[],
				backgroundChange:false,
				phoneNav:false,
				phoneNav2:false

			}
		},

		methods: {
			handleSelect(key, keyPath) {
				sessionStorage.setItem("currentPage","")

				sessionStorage.setItem("catId","")

				this.show= false;

				if (key !="/en/Home"){
					this.backgroundChange=true
					window.removeEventListener('scroll', this.scrolling);
				}else{
					this.backgroundChange=false
					window.addEventListener("scroll", this.scrolling);
				}
			},
			toggleShopShow(){

				this.show= !this.show;
			},
			_isMobile() {
				let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
				return flag;
			},
			scrolling(){
				let s= window.pageYOffset ||
						document.documentElement.scrollTop ||
						document.body.scrollTop

				if (s>= window.innerHeight){
					this.backgroundChange=true

				}else{
					this.backgroundChange=false
				}
			},




		},
		watch:{
			$route(to,from){
				if (to.path !="/en/Home"){
					this.backgroundChange=true
					window.removeEventListener('scroll', this.scrolling);
				}else{
					this.backgroundChange=false
					window.addEventListener("scroll", this.scrolling);
				}
			}
		},
		beforeMount(){
			if (this._isMobile()) {
				this.isPC=false;
			} else {

				this.isPC=true;
			}
			if(sessionStorage.getItem("chtheader")==""||sessionStorage.getItem("chtheader")==null){
				request.get("/nav/header/en").then(res =>{

					this.list = res.data;
					sessionStorage.setItem("chtheader",JSON.stringify(this.list))

				}).catch((res)=>{
				})

			}else{
				this.list=JSON.parse(sessionStorage.getItem('chtheader'))
			}


		},

		mounted() {

			if (this.$route.path !="/en/Home"){
				this.backgroundChange=true
				window.removeEventListener('scroll', this.scrolling);
			}else{
				this.backgroundChange=false
				window.addEventListener("scroll", this.scrolling);
			}




		},

		// beforeDestroy() {
		// 	window.removeEventListener('scroll', this.scrolling);
		// },

	}
</script>

<style scoped lang="less">


	.backgroundChange{
		background-color: white !important;

		font-family: HarmonyOS_Sans_SC_Medium;
		/deep/
		.el-menu--horizontal>.el-menu-item{
			color: #000000;
		}
		/deep/
		.el-sub-menu__title{
			font-size: 16px !important;
			color:#000000 !important;
		}
		/deep/
		.el-menu--horizontal>.el-menu-item.is-active {
			border-bottom: none !important;
			font-weight: bold !important;
			color: #000000 !important;
			background:transparent !important;

		}
	}
	.el-menu-demo{
		padding-top: 10px;
		padding-right: 40px;
		font-family: HarmonyOS_Sans_SC_Medium;
		background:transparent;
		color:white;
	}
	/deep/
	.el-menu--horizontal>.el-menu-item.is-active {
		border-bottom: none !important;
		font-weight: bold !important;
		color: white !important;
		background:transparent !important;

	}

	/deep/
	.el-menu--horizontal>.el-menu-item{
		color: #ffffff;
	}
	/deep/
	.el-sub-menu__title{

		color:#ffffff !important;
	}
	/deep/
	.el-menu--horizontal>.el-sub-menu:hover{
		background:transparent !important;

	}
	/deep/
	.el-menu--horizontal>.el-sub-menu .el-sub-menu__title:hover{
		background-color:transparent !important;

	}
	.el-menu--horizontal>.el-menu-item.is-active:hover{
		background:transparent !important;
		font-weight: 600 !important;

	}
	/deep/
	.el-sub-menu .el-menu-item{
		color:#000000 !important;
		font-size: 14px !important;
	}



	.el-menu.el-menu--horizontal{
		border: none;


	}
	.el-menu-item:hover{

		background:transparent !important;

		font-weight: 600 !important;



	}
	.item {
		height: 65px !important;
		line-height: 65px !important;

	}

	.el-menu--horizontal>.el-sub-menu .el-sub-menu__title,.el-menu-item{

		font-size: 16px !important;
		height: 65px;
		line-height: 65px;
	}
	.el-menu-item{

		width: 8rem;

	}
	.logo{
		width: 400px;padding-left: 120px;height: 65px;
	}
	/*---------------------------------------mobile terminal--------------------------------------*/

	.phoneNav{
		margin-top: 1px;
		background: white;
		animation-name: show;
		animation-duration: 2s;
		z-index: 999;
		li{
			border-bottom:  1px solid rgba(0,0,0,0.08);
			box-sizing: border-box;
		}
		li:last-child{
			border-bottom: none;

		}
		li:hover{
			background: rgba(64,158,255,0.1);
		}
		a {
			color: #333;
			font-size: 16px;
			line-height: 20px;
			padding: 15px 3%;
			box-sizing: border-box;
			display: inline-block;
			font-weight: normal;
			width: 100%;
			z-index: 2;
			text-transform: capitalize;
			text-decoration: none;
		}
	}
	.phoneNav2{
		animation-name: show;
		animation-duration: 2s;
		margin-top: 1px;

		a {
			color: #333;
			font-size: 16px;
			line-height: 20px;

			box-sizing: border-box;
			display: inline-block;
			font-weight: normal;
			width: 100%;
			z-index: 2;
			text-decoration: none;
		}

		.el-row{
			background-color: white;

		}
		.el-col:hover{
			background: rgba(64,158,255,0.1);
		}
		.el-col{
			padding: 10px;
			border-right:  1px solid rgba(0,0,0,0.08);
			box-sizing: border-box;
		}
		.el-col:last-child{
			border-right: none;

		}
	}


	@keyframes show {
		0% { opacity: 0; }
		100% { opacity: 1; }
	}



</style>